export const INPUT_DATE_PICKER_ICON_POSITION = {
  START: 'start',
  END: 'end',
} as const;

export type InputDatePickerIconPosition =
  (typeof INPUT_DATE_PICKER_ICON_POSITION)[keyof typeof INPUT_DATE_PICKER_ICON_POSITION];

export interface InputDatePickerProps {
  allowClear?: boolean;
  align?: 'start' | 'center' | 'end';
  ariaLabel?: string;
  className?: string;
  defaultValue?: string;
  disablePast?: boolean;
  displayFormat?: string;
  iconPosition?: InputDatePickerIconPosition;
  id: string;
  onChange: (value: string) => void;
  placeholder?: string;
  value: string;
}
